import { CommmonGet, CommmonPost, CommmonPut } from '@/util/network/api';
import { baseURL } from '@/util/network/axios';
import { CheckEmail, CheckIdCard, CheckPhone, beforeuploadImage, keyPureMath, replyCN, replyNum, trimFormValues, uploadparams } from '@/util/public';
import { Col, Form, Input, Radio, Row, Select, Spin, Upload, message, Modal } from 'antd';
import { LgCheckbox, LgDatePicker, LgInput } from 'lancoo-web-ui';
import { LgSelect } from "@/components/select"
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUserId, selectUserInfo } from '../../../store/reducers/userInfo';
import { defaultBasicOrdere, generateOrderedArray } from '../common/publicFunc';
import SourceAddre from './SelectAddress/sourceAddre';
import './addOrupEnroll.scss';
import ExtraItem from './extraItem';
import NumericInput from './numericInput';
import { selectSchoolId } from '../../../store/reducers/schoolInfo';
import { CustomSchoolSelect } from './components/CustomSchoolSelect';
import { jinzhouTemplateParams } from '@/page/constants';

const  AddOrupEnroll = forwardRef((props: any, ref: any) => {
    const {
        selectItem,
        type, // 1 新增 2 修改 3 查看
        setCancelFlag, // 取消按钮是否显示
        setShowInfo,
        preview = false
    } = props;

    const userId = useSelector(selectUserId);
    const { userType } = useSelector(selectUserInfo);
    const schoolId = useSelector(selectSchoolId);

    const [form] = Form.useForm();
    const [extraform] = Form.useForm();

    // 显示字段
    const [extramsg, setextramsg] = useState<any>({});
    // 内容信息
    const [editmsg, seteditmsg] = useState<any>(null);

    // 文件
    const [avatr, setavatr] = useState<any>(null);
    const [, setfile] = useState<any[]>([]);
    // 刷新
    const [isloading, setIsloading] = useState<boolean>(false);
    // 是否给编辑
    const [canUpdateInfo, setCanUpdateInfo] = useState<boolean>(true);
    const [isPreview, setIsPreview] = useState<boolean>(false);

    // 基本信息顺序
    const [basicOrdere, setBasicOrdere] = useState<string[]>(defaultBasicOrdere);
    const [majorList, setMajorList] = useState<any[]>([]);

    const [pageKey, setPageKey] = useState<number>(0);

    const [, forceUpdate] = useState<any>(null);
    const [formKey, setFormKey] = useState<number>(0);
    const [enrollData, setEnrollData] = useState<any>(null);
    const [numberCheck, setNumberCheck] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalTip, setModalTip] = useState("");

    useImperativeHandle(ref, () => ({
        form,
        avatr,
        setavatr,
        extraform,
        postData
    }));

    // 提交报名信息
    const postData = () => {
        return new Promise((resolve, reject) => {
            // 去掉两边空格
            trimFormValues(form);
            trimFormValues(extraform);
            
            form.validateFields().then((res: any) => {
                // let candidateNumberCheck = false, caNumber = res.candidateNumber;
                // if(caNumber?.length === 14 && ["89","99"].includes(String(caNumber).substr(8, 10))){
                //     candidateNumberCheck = true;
                // }
                // setNumberCheck(candidateNumberCheck);
                // setModalVisible(true)
                // return;
                extraform.validateFields().then(() => {
                    if (res.firstVolunteer && res.secondVolunteer && res.firstVolunteer === res.secondVolunteer) {
                        message.destroy();
                        message.error('报名志愿不能重复');
                        return;
                    } else if (res.firstVolunteer && res.thirdVolunteer && res.firstVolunteer === res.thirdVolunteer) {
                        message.destroy();
                        message.error('报名志愿不能重复');
                        return;
                    } else if (res.secondVolunteer && res.thirdVolunteer && res.secondVolunteer === res.thirdVolunteer) {
                        message.destroy();
                        message.error('报名志愿不能重复');
                        return;
                    }
                    let postdata = {
                        planId: selectItem.planId,
                        ...form.getFieldsValue(),
                        avatar: avatr ? [avatr.resId] : [],
                        avatarId: avatr ? [avatr.resId] : [],
                        otherInfo: extramsg && extramsg.fields && extramsg.fields.length > 0 ?
                            extramsg.fields.map((item: any, index: number) => {
                                // const extravalue = extraform.getFieldValue('extra' + index + 1 + (item.type === 11 ? '11' : ''));
                                const extravalue = extraform.getFieldValue('extra' + index + 1);
                                let others = null
                                if (item.type == 8) {
                                    let index = extravalue.indexOf('other:')
                                    if (index != -1) {
                                        others = extravalue
                                    }
                                }
                                return {
                                    fieldId: item.fieldId,
                                    type: item.type,
                                    value: (item.type == 1 || item.type == 4 || item.type == 7 || item.type == 10 || item.type == 12) ? extravalue :
                                        (item.type == 2 || item.type == 11 || item.type == 8) ? extravalue == -1 ? "" : extravalue : "",
                                    choice: item.type == 2 || item.type == 8 ?
                                        others != null ? [] : [extravalue] : [],
                                    enclosuresId: item.type == 6 && extravalue && extravalue.length > 0 ?
                                        extravalue.map((item1: any) => {
                                            if (item1.response) {
                                                return item1.response.data.resId
                                            } else {
                                                return item1.uid
                                            }
                                            // return item1.response.data.resId
                                        })
                                        : [],
                                }
                            }) : []
                    }
                    let candidateNumberCheck = false, caNumber = res.candidateNumber;
                    if(caNumber?.length === 14 && ["89","99"].includes(String(caNumber).substr(8, 10))){
                        candidateNumberCheck = true;
                    }
                    setNumberCheck(candidateNumberCheck);
                    if (postdata?.courseList?.length > 0) {
                        postdata.courseList = postdata.courseList.map(ele => {
                            const subjectName = selectItem.courseList.find(el => el.subjectId === ele)?.subjectName || ''
                            return {
                                subjectId: ele,
                                subjectName
                            }
                        })
                    }
                    let url = selectItem?.enableApply === 3 ? '/portal/plan/apply' : `/portal/Onlinedeclaration/${(userType === 20 && userId) ? 'teacherProxyEnroll' : 'operation'}`
                    postdata.userId = userId
                    if (selectItem?.enableApply === 3) {
                        CommmonPut(url, postdata).then((res:any) => {
                            setModalTip(`报名信息修改成功`);
                            setModalVisible(true);
                            resolve({...res, postData: postdata});
                        }).catch(error => {
                            reject({ msg: error?.msg || '报名失败，请重新报名', type: 'error' });
                        })
                    } else {
                        if (isPreview) {
                            CommmonPost(url, postdata).then((res:any) => {
                                setModalTip(`报名信息提交成功`);
                                setModalVisible(true);
                                resolve({...res, postData: postdata});
                            }).catch(error => {
                                reject({ msg: error?.msg || '报名失败，请重新报名', type: 'error' });
                            })
                        } else {
                            setShowInfo(true);
                        }
                    }

                }).catch(error => {
                    reject({ msg: '校验不通过', type: 'warning' });
                    console.log(error);
                })
            }).catch(error => {
                extraform.validateFields()
                reject({ msg: '校验不通过', type: 'warning' });
                console.log(error);
            })
        })
    }

    const uploaddone = (info: any) => {
        if (info.file.status === 'done') {
            const res = info.file.response
            console.log(res);
            if (res.status !== 0) {
                message.warning(res.msg)
                form.setFieldsValue({ avatar: !avatr ? null : `C:\\fakepath\\${avatr.originalName}` })
            } else {
                // 头像
                let coverobj = {
                    originalName: res.data.originalName,
                    resId: res.data.resId,
                    url: res.data.preUrl
                }
                setavatr(coverobj);
                form.validateFields(['avatar']);
            }
        }
    }

    // 获取手动报名用额外字段
    const getExtraMsg = (planId: number, callback?: (newDate: any) => void | Function) => {
        setIsloading(true);
        CommmonGet("admissionManage/planOtherInfo", { planId }).then((res: any) => {
            setextramsg(() => res?.data || {});
            // 基本信息顺序
            const orderedArray = generateOrderedArray(res?.data?.basicField);
            setBasicOrdere(orderedArray);
            callback && callback(res?.data || {});
            !callback && setIsloading(false);
        }).catch(error => {
            message.destroy();
            message.warning(error?.msg || error?.message || '获取额外字段失败');
            setIsloading(false);
        })
    };

    useEffect(() => {
        selectItem && getExtraMsg(selectItem.planId, (newDate: any) => {
            if (selectItem?.enableApply !== 3 && type !== 3) {
                setIsloading(false);
                return
            }
            CommmonGet("/admissionManage/userInfo", {
                planId: selectItem.planId,
                userId,
                templateId: selectItem.templateId,
                apply: type !== 3
            }).then((res: any) => {
                console.log(res, 'res')
                let data = res?.data || {};

                setEnrollData(data);

                setCanUpdateInfo(data?.canUpdateInfo);
                setCancelFlag && setCancelFlag(data?.canUpdateInfo);

                if (data?.courseList?.length > 0) {
                    data.courseList = data.courseList.map(ele => ele.subjectId);
                }
                form.setFieldsValue({ ...data });
                setFormKey(formKey + 1);
                data?.avatar && setavatr(data.avatar);

                extramsg.supplementaryInfoDTOList = data.otherInfo || {};
                seteditmsg(extramsg);

            }).finally(() => setIsloading(false))
        })
    }, [selectItem]);

    useEffect(() => {
        console.log(type, canUpdateInfo, preview, 'detail')
        setIsPreview(type === 3 || !canUpdateInfo || preview);
        if (!(type === 3 || !canUpdateInfo || preview) && (selectItem?.enableApply !== 3 || enrollData?.idCard)) {
            CommmonGet(`/majorCampus/${selectItem?.limitTheNumOfPro ? 'canApplyForMajors' : 'infoList'}`, {
                planId: selectItem.planId,
                ...(selectItem?.enableApply === 3 ? { idCard: enrollData.idCard } : []),
            }).then((res: any) => {
                setMajorList(() => res?.data || []);
            }).catch((err: any) => {
                setMajorList([]);
            })
        }
    }, [type, canUpdateInfo, selectItem, enrollData]);

    const getColSpan = (item: any) => {
        let temp = 8;
        if (
            item?.type === 10 ||
            item?.type === 2 ||
            item?.type === 6 ||
            item?.type === 12 ||
            type === 3
        ) {
            temp = 24;
        } else {
            temp = 8;
        }

        return temp;
    };

    const baseInfoList = useMemo(() => {
        console.log(basicOrdere, 'basicOrdere')
        let list = basicOrdere.map((item: any, index: number) => {
            let showCont = null
            switch (item) {
                case 'avatar':
                    showCont = extramsg?.basicField?.avatar?.collect &&
                        <Form.Item
                            className="avatr"
                            name="avatar"
                            // initialValue={""}
                            wrapperCol={{ span: 23 }}
                            rules={[{ required: extramsg?.basicField?.avatar?.need, message: '请上传证件照!' }]}
                        >
                            {isPreview ?
                                <div
                                    className="uploadcover"
                                    style={{
                                        background: `url(${avatr?.url}) no-repeat center`,
                                        cursor: 'default'
                                    }}
                                /> :
                                <div>
                                    <Upload
                                        action={baseURL + "/common/uploadFile"}
                                        headers={{ schoolid: schoolId }}
                                        maxCount={1}
                                        data={(file) => uploadparams(file, "image_file")}
                                        accept="image/*"
                                        showUploadList={false}
                                        beforeUpload={beforeuploadImage}
                                        onChange={file => uploaddone(file)}
                                    >
                                        {
                                            avatr ?
                                                // <img style={{ height: "64px", width: "114px", cursor: "pointer",objectFit:"contain" }} src={covermsg.url}></img> :
                                                <div
                                                    className="uploadcover"
                                                    style={{
                                                        background: `url(${avatr.url}) no-repeat center`,
                                                        // backgroundRepeat: "no-repeat",
                                                        // backgroundSize: "cover",
                                                    }}
                                                >
                                                    <div className="chooseImg">选择图片</div>
                                                </div> :
                                                <div className="uploadcover">
                                                    <div className="chooseImg">选择图片</div>
                                                </div>
                                        }
                                    </Upload>
                                    <div
                                        style={{
                                            color: "#c1c1c1",
                                            height: "20px",
                                            width: "125px",
                                            fontSize: "12px", position: "relative"
                                        }}>
                                        <p>
                                            {
                                                extramsg?.basicField?.avatar?.need ?
                                                    <span style={{ color: "red" }}>*</span> : null
                                            }(建议:一寸蓝底证件照)
                                        </p>
                                    </div>
                                </div>
                            }
                        </Form.Item>
                    break;
                case 'name':
                    showCont = extramsg?.basicField?.name?.collect &&
                        <Form.Item
                            label={"姓名"}
                            name="name"
                            rules={[{ required: type !== 3 ? true : false, message: '姓名不能为空!' }]}
                        >
                            {isPreview ? <span>{form.getFieldValue("name") || '--'}</span> :
                                <LgInput
                                    maxLength={25}
                                    placeholder="请输入姓名"
                                    autoComplete='off'
                                />
                            }
                        </Form.Item>
                    break;
                case 'gender':
                    showCont = extramsg?.basicField?.gender?.collect &&
                        <Form.Item
                            label="性别"
                            name={"gender"}
                            initialValue={0}
                            rules={[{ required: type !== 3 ? true : false, message: '请选择性别!' }]}
                        >
                            {isPreview ? <span>{form.getFieldValue("gender") === 0 ? "男" : "女"}</span> :
                                <Radio.Group>
                                    <Radio value={0}>男</Radio>
                                    <Radio value={1}>女</Radio>
                                </Radio.Group>
                            }
                        </Form.Item>
                    break;
                case 'idCard':
                    showCont = extramsg?.basicField?.idCard?.collect &&
                        <Form.Item
                            label="身份证号"
                            name="idCard"
                            rules={[
                                {
                                    required: type !== 3 ? true : false,
                                    message: '身份证号不能为空!'
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || !CheckIdCard(value)) {
                                            return Promise.resolve();
                                        } else if (value && CheckIdCard(value)) {
                                            return Promise.reject(new Error(CheckIdCard(value)));
                                        }
                                        return Promise.reject(new Error('身份证格式有误'));
                                    },
                                }),
                            ]}
                            getValueFromEvent={
                                (event) => {
                                    return replyCN(event)
                                }
                            }
                        >
                            {isPreview ? <span>{form.getFieldValue("idCard") || '--'}</span> :
                                <LgInput
                                    placeholder="请输入身份证号"
                                    // onKeyPress={(event) => CheckIdCard(event)}
                                    readOnly={selectItem?.enableApply === 3 ? true : false}
                                    disabled={selectItem?.enableApply === 3 ? true : false}
                                    autoComplete='off'
                                    maxLength={18}
                                />
                            }
                        </Form.Item>
                    break;
                case 'phone':
                    showCont = extramsg?.basicField?.phone?.collect &&
                        <Form.Item
                            label="联系方式"
                            name="phone"
                            rules={[{
                                required: extramsg?.basicField?.phone?.need,
                                message: '联系方式不能为空!'
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || CheckPhone(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('联系方式格式有误'));
                                },
                            }),
                            ]}
                            getValueFromEvent={
                                (event) => {
                                    return replyNum(event)
                                }
                            }
                        >
                            {isPreview ? <span>{form.getFieldValue("phone") || '--'}</span> :
                                <LgInput
                                    placeholder="请输入联系方式"
                                    type={'tel'}
                                    maxLength={11}
                                    autoComplete='off'
                                />
                            }
                        </Form.Item>
                    break;
                case 'email':
                    showCont = extramsg?.basicField?.email?.collect &&
                        <Form.Item
                            label="电子邮箱"
                            name="email"
                            rules={[
                                {
                                    required: extramsg?.basicField?.email?.need, message: '电子邮箱不能为空!'
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || CheckEmail(value)) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('电子邮箱格式有误'));
                                    },
                                }),
                            ]}
                        >
                            {isPreview ? <span>{form.getFieldValue("email") || '--'}</span> :
                                <LgInput
                                    placeholder="请输入电子邮箱"
                                    // type={'email'}
                                    autoComplete='off'
                                    maxLength={32}
                                />
                            }
                        </Form.Item>
                    break;
                case 'enrollMajor':
                    showCont = extramsg?.basicField?.enrollMajor?.collect &&
                        <Form.Item
                            label="报名专业"
                            name="enrollMajor"
                            initialValue={null}
                            rules={[
                                {
                                    required: extramsg?.basicField?.enrollMajor?.need, message: '报名专业不能为空!'
                                }
                            ]}
                        >
                            {isPreview ?
                                <span>
                                    {
                                        extramsg?.basicField?.enrollMajor?.options?.find((item: any) => item.value == form.getFieldValue("enrollMajor"))?.name ||
                                        extramsg?.basicField?.enrollMajor?.options?.find((item: any) => item.value == form.getFieldValue("enrollMajor"))?.label ||
                                        '--'
                                    }
                                </span> :
                                <Select
                                    options={extramsg?.basicField?.enrollMajor?.options?.map((item: any, index: number) => {
                                        return {
                                            label: item.name || item.label || '',
                                            value: item.value
                                        }
                                    })}
                                    placeholder="请选择报名专业"
                                    onChange={(_, curOption: any) => {
                                        form.setFieldValue('enrollMajor', curOption.value);
                                    }}
                                    className='CommonSelect enrollMajor'
                                    // style={{ width: 400 }}
                                    getPopupContainer={(node) => node.parentNode}
                                />
                            }
                        </Form.Item>
                    break;

                case 'trainingStage':
                    const trainingStageOptions: any = extramsg?.basicField?.trainingStage?.options;
                    showCont = extramsg?.basicField?.trainingStage?.collect &&
                        <Form.Item
                            label="培养层次"
                            name="trainingStage"
                            initialValue={null}
                            rules={[
                                {
                                    required: extramsg?.basicField?.trainingStage?.need, message: '培养层次不能为空!'
                                }
                            ]}
                        >
                            {isPreview ?
                                <span>
                                    {
                                        trainingStageOptions?.find((item: any) => item.value == form.getFieldValue("trainingStage"))?.name ||
                                        trainingStageOptions?.find((item: any) => item.value == form.getFieldValue("trainingStage"))?.label ||
                                        '--'
                                    }
                                </span> :
                                <Select
                                    options={trainingStageOptions?.map((item: any, index: number) => {
                                        return {
                                            label: item.name || item.label || '',
                                            value: item.value
                                        }
                                    })}
                                    placeholder="请选择培养层次"
                                    onChange={(_, curOption: any) => {
                                        form.setFieldValue('trainingStage', curOption.value);
                                    }}
                                    className='CommonSelect trainingStage'
                                    // style={{ width: 400 }}
                                    getPopupContainer={(node) => node.parentNode}
                                />
                            }
                        </Form.Item>
                    break;
                case 'firstVolunteer':
                    let firstVolunteerDisabled: boolean = false;
                    let firstVolunteerOptions: any[] = extramsg?.basicField?.firstVolunteer?.options;
                    if (extramsg?.basicField?.trainingStage?.collect && !isPreview) {
                        if (!form.getFieldValue('trainingStage')) {
                            firstVolunteerDisabled = true;
                        } else {
                            const temp = majorList?.filter((item: any) => item?.trainingStageId?.toString() === form.getFieldValue('trainingStage')?.toString());
                            firstVolunteerOptions = firstVolunteerOptions?.filter((item: any) => temp.some(major => item.value === major.majorCode));

                            if (majorList.length > 0 && firstVolunteerOptions.findIndex((item: any) => item.value === form.getFieldValue('firstVolunteer')) === -1) {
                                form.setFieldsValue({
                                    firstVolunteer: undefined // 清空 第一志愿
                                });
                            }
                        }
                    }

                    showCont = extramsg?.basicField?.firstVolunteer?.collect &&
                        <Form.Item
                            label="第一志愿"
                            name="firstVolunteer"
                            initialValue={null}
                            rules={[
                                {
                                    required: extramsg?.basicField?.firstVolunteer?.need, message: '第一志愿不能为空!'
                                }
                            ]}
                        >
                            {isPreview ?
                                <span>
                                    {
                                        firstVolunteerOptions?.find((item: any) => item.value == form.getFieldValue("firstVolunteer"))?.name ||
                                        firstVolunteerOptions?.find((item: any) => item.value == form.getFieldValue("firstVolunteer"))?.label ||
                                        '--'
                                    }
                                </span> :
                                <Select
                                    disabled={firstVolunteerDisabled}
                                    options={firstVolunteerOptions?.map((item: any, index: number) => {
                                        return {
                                            label: item.name || item.label || '',
                                            value: item.value
                                        }
                                    })}
                                    placeholder="请选择第一志愿"
                                    onChange={(_, curOption: any) => {
                                        form.setFieldValue('firstVolunteer', curOption.value);
                                    }}
                                    className='CommonSelect firstVolunteer'
                                    // style={{ width: 400 }}
                                    getPopupContainer={(node) => node.parentNode}
                                />
                            }
                        </Form.Item>
                    break;
                case 'secondVolunteer':
                    let secondVolunteerDisabled: boolean = false;
                    let secondVolunteerOptions: any[] = extramsg?.basicField?.secondVolunteer?.options;
                    if (extramsg?.basicField?.trainingStage?.collect && !isPreview) {
                        if (!form.getFieldValue('trainingStage')) {
                            secondVolunteerDisabled = true;
                        } else {
                            const temp = majorList?.filter((item: any) => item?.trainingStageId?.toString() === form.getFieldValue('trainingStage')?.toString());
                            secondVolunteerOptions = secondVolunteerOptions?.filter((item: any) => temp.some(major => item.value === major.majorCode));

                            if (majorList.length > 0 && secondVolunteerOptions.findIndex((item: any) => item.value === form.getFieldValue('secondVolunteer')) === -1) {
                                form.setFieldsValue({
                                    secondVolunteer: undefined, // 清空 第二志愿
                                });
                            }
                        }
                    }

                    showCont = extramsg?.basicField?.secondVolunteer?.collect &&
                        <Form.Item
                            label="第二志愿"
                            name="secondVolunteer"
                            initialValue={null}
                            rules={[
                                {
                                    required: extramsg?.basicField?.secondVolunteer?.need, message: '第二志愿不能为空!'
                                }
                            ]}
                        >
                            {isPreview ?
                                <span>
                                    {
                                        secondVolunteerOptions?.find((item: any) => item.value == form.getFieldValue("secondVolunteer"))?.name ||
                                        secondVolunteerOptions?.find((item: any) => item.value == form.getFieldValue("secondVolunteer"))?.label ||
                                        '--'
                                    }
                                </span> :
                                <Select
                                    disabled={secondVolunteerDisabled}
                                    options={secondVolunteerOptions?.map((item: any, index: number) => {
                                        return {
                                            label: item.name || item.label || '',
                                            value: item.value
                                        }
                                    })}
                                    placeholder="请选择第二志愿"
                                    onChange={(_, curOption: any) => {
                                        form.setFieldValue('secondVolunteer', curOption?.value);
                                    }}
                                    className='CommonSelect secondVolunteer'
                                    // style={{ width: 400 }}
                                    getPopupContainer={(node) => node.parentNode}
                                    allowClear
                                />
                            }
                        </Form.Item>
                    break;
                case 'thirdVolunteer':
                    let thirdVolunteerDisabled: boolean = false;
                    let thirdVolunteerOptions: any[] = extramsg?.basicField?.thirdVolunteer?.options;
                    if (extramsg?.basicField?.trainingStage?.collect && !isPreview) {
                        if (!form.getFieldValue('trainingStage')) {
                            thirdVolunteerDisabled = true;
                        } else {
                            const temp = majorList?.filter((item: any) => item?.trainingStageId?.toString() === form.getFieldValue('trainingStage')?.toString());
                            thirdVolunteerOptions = thirdVolunteerOptions?.filter((item: any) => temp.some(major => item.value === major.majorCode));

                            if (majorList.length > 0 && thirdVolunteerOptions.findIndex((item: any) => item.value === form.getFieldValue('thirdVolunteer')) === -1) {
                                form.setFieldsValue({
                                    thirdVolunteer: undefined, // 清空 第三志愿
                                });
                            }
                        }
                    }

                    showCont = extramsg?.basicField?.thirdVolunteer?.collect &&
                        <Form.Item
                            label="第三志愿"
                            name="thirdVolunteer"
                            initialValue={null}
                            rules={[
                                {
                                    required: extramsg?.basicField?.thirdVolunteer?.need, message: '第三志愿不能为空!'
                                }
                            ]}
                        >
                            {isPreview ?
                                <span>
                                    {
                                        thirdVolunteerOptions?.find((item: any) => item.value == form.getFieldValue("thirdVolunteer"))?.name ||
                                        thirdVolunteerOptions?.find((item: any) => item.value == form.getFieldValue("thirdVolunteer"))?.label ||
                                        '--'
                                    }
                                </span> :
                                <Select
                                    disabled={thirdVolunteerDisabled}
                                    options={thirdVolunteerOptions?.map((item: any, index: number) => {
                                        return {
                                            label: item.name || item.label || '',
                                            value: item.value
                                        }
                                    })}
                                    placeholder="请选择第三志愿"
                                    onChange={(_, curOption: any) => {
                                        form.setFieldValue('thirdVolunteer', curOption?.value);
                                    }}
                                    className='CommonSelect thirdVolunteer'
                                    // style={{ width: 400 }}
                                    getPopupContainer={(node) => node.parentNode}
                                    allowClear
                                />
                            }
                        </Form.Item>
                    break;
                case 'allowAdjust':
                    showCont = extramsg?.basicField?.allowAdjust?.collect &&
                        <Form.Item
                            label="是否允许调剂"
                            name={"allowAdjust"}
                            initialValue={true}
                            rules={[{ required: extramsg?.basicField?.allowAdjust?.need, message: '请选择是否允许调剂!' }]}
                        >
                            {isPreview ? <span>{form.getFieldValue("allowAdjust") ? "是" : "否"}</span> :
                                <Radio.Group>
                                    <Radio value={true}>是</Radio>
                                    <Radio value={false}>否</Radio>
                                </Radio.Group>
                            }
                        </Form.Item>
                    break;

                case 'source':
                    showCont = extramsg?.basicField?.source?.collect &&
                        <Form.Item
                            label="生源地"
                            name="source"
                            rules={[
                                {
                                    required: extramsg?.basicField?.source?.need,
                                    message: '生源地不能为空!'
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (value?.split('~')?.[0].length < 4 && extramsg?.basicField?.source?.need) {
                                            return Promise.reject(new Error(`生源地地区需要选择完！`));
                                        }
                                        return Promise.resolve();
                                    }
                                })
                            ]}
                        >
                            {isPreview ? <span>{form.getFieldValue("source") ? form.getFieldValue("source")?.split?.('~')?.[1] : "--"}</span> :
                                <SourceAddre
                                    required={extramsg?.basicField?.source?.need}
                                    onChange={(value: string) => {
                                        form.validateFields(['source'])
                                    }}
                                />
                            }
                        </Form.Item>
                    break;
                case 'talentedStudent':
                    showCont = extramsg?.basicField?.talentedStudent?.collect &&
                        <Form.Item
                            label="特长生"
                            name="talentedStudent"
                            initialValue={'否'}
                            rules={[
                                {
                                    required: extramsg?.basicField?.talentedStudent?.need, message: '特长生不能为空!'
                                }
                            ]}
                        >
                            {isPreview ? <span>{form.getFieldValue("talentedStudent") || '--'}</span> :
                                <Radio.Group>
                                    <Radio value={'是'}>是</Radio>
                                    <Radio value={'否'}>否</Radio>
                                </Radio.Group>
                            }
                        </Form.Item>
                    break;
                case 'languageScore':
                    showCont = extramsg?.basicField?.languageScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="语文分数"
                            name="languageScore"
                            max={150}
                            isPreview={isPreview}
                        />
                    break;
                case 'mathScore':
                    showCont = extramsg?.basicField?.mathScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="数学分数"
                            name="mathScore"
                            max={150}
                            isPreview={isPreview}
                        />
                    break;
                case 'englishScore':
                    showCont = extramsg?.basicField?.englishScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="英语分数"
                            name="englishScore"
                            max={150}
                            isPreview={isPreview}
                        />
                    break;
                case 'physicsScore':
                    showCont = extramsg?.basicField?.physicsScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="物理分数"
                            name="physicsScore"
                            max={100}
                            isPreview={isPreview}
                        />
                    break;
                case 'chemistryScore':
                    showCont = extramsg?.basicField?.chemistryScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="化学分数"
                            name="chemistryScore"
                            max={100}
                            isPreview={isPreview}
                        />
                    break;
                case 'biologyScore':
                    showCont = extramsg?.basicField?.biologyScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="生物分数"
                            name="biologyScore"
                            max={100}
                            isPreview={isPreview}
                        />
                    break;
                case 'politicScore':
                    showCont = extramsg?.basicField?.politicScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="政治分数"
                            name="politicScore"
                            max={100}
                            isPreview={isPreview}
                        />
                    break;
                case 'historyScore':
                    showCont = extramsg?.basicField?.historyScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="历史分数"
                            name="historyScore"
                            max={100}
                            isPreview={isPreview}
                        />
                    break;
                case 'geographyScore':
                    showCont = extramsg?.basicField?.geographyScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="地理分数"
                            name="geographyScore"
                            max={100}
                            isPreview={isPreview}
                        />
                    break;
                case 'sportScore':
                    showCont = extramsg?.basicField?.sportScore?.collect &&
                        <NumericInput
                            form={form}
                            extramsg={extramsg}
                            label="体育分数"
                            name="sportScore"
                            max={100}
                            isPreview={isPreview}
                        />
                    break;
                // 鮀滨
                case 'returnPremium':
                    showCont = extramsg?.basicField?.returnPremium?.collect &&
                        <Form.Item
                            label="是否退费"
                            name={"returnPremium"}
                            initialValue={0}
                            rules={[{ required: extramsg?.basicField?.returnPremium?.need, message: '是否退费不能为空!' }]}
                        >
                            {isPreview ? <span>{form.getFieldValue("returnPremium") === 1 ? "是" : "否"}</span> :
                                <Radio.Group>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </Radio.Group>
                            }
                        </Form.Item>
                    break;
                case 'pay':
                    showCont = extramsg?.basicField?.returnPremium?.collect &&
                        <Form.Item
                            label="是否缴费"
                            name={"pay"}
                            initialValue={1}
                            rules={[{ required: extramsg?.basicField?.pay?.need, message: '是否缴费不能为空!' }]}
                        >
                            {isPreview ? <span>{form.getFieldValue("pay") === 1 ? "是" : "否"}</span> :
                                <Radio.Group>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </Radio.Group>
                            }
                        </Form.Item>
                    break;
                case 'freeTuition':
                    showCont = extramsg?.basicField?.freeTuition?.collect &&
                        <Form.Item
                            label="是否免学费"
                            name={"freeTuition"}
                            // initialValue={0}
                            rules={[{ required: extramsg?.basicField?.freeTuition?.need, message: '是否免学费不能为空!' }]}
                        >
                            {isPreview ?
                                <span>
                                    {
                                        (form.getFieldValue("freeTuition") !== undefined && form.getFieldValue("freeTuition") !== null) ?
                                            form.getFieldValue("freeTuition") === 1 ? "是" : "否" : '--'
                                    }
                                </span> :
                                <Radio.Group>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </Radio.Group>}
                        </Form.Item>
                    break;
                case 'putUp':
                    showCont = extramsg?.basicField?.putUp?.collect &&
                        <Form.Item
                            label="是否住宿"
                            name={"putUp"}
                            // initialValue={0}
                            rules={[{ required: extramsg?.basicField?.putUp?.need, message: '是否住宿不能为空!' }]}
                        >
                            {isPreview ?
                                <span>
                                    {
                                        (form.getFieldValue("putUp") !== undefined && form.getFieldValue("putUp") !== null) ?
                                            form.getFieldValue("putUp") === 1 ? "是" : "否" : '--'
                                    }
                                </span> :
                                <Radio.Group>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </Radio.Group>
                            }
                        </Form.Item>
                    break;
                case 'enroll32Subsection':
                    showCont = extramsg?.basicField?.enroll32Subsection?.collect &&
                        <Form.Item
                            label="是否报读三二分段"
                            name={"enroll32Subsection"}
                            // initialValue={0}
                            rules={[{ required: extramsg?.basicField?.enroll32Subsection?.need, message: '是否报读三二分段不能为空!' }]}
                        >
                            {isPreview ?
                                <span>
                                    {
                                        (form.getFieldValue("enroll32Subsection") !== undefined && form.getFieldValue("enroll32Subsection") !== null) ?
                                            form.getFieldValue("enroll32Subsection") === 1 ? "是" : "否" : '--'
                                    }
                                </span> :
                                <Radio.Group>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </Radio.Group>
                            }
                        </Form.Item>
                    break;
                case 'registrationNumber':
                    showCont = extramsg?.basicField?.registrationNumber?.collect &&
                        <Form.Item
                            label="中考报名号"
                            name="registrationNumber"
                            rules={[{
                                required: extramsg?.basicField?.registrationNumber?.need, message: '中考报名号不能为空!'
                            }]}
                            getValueFromEvent={(e: any) => {
                                const { value } = e.target;
                                const tempArr = value.split(".");
                                if (tempArr[1]?.length) {
                                    return `${tempArr[0]}.${tempArr[1].slice(0, 1)}`.replace(
                                        // /[^\d{1,}\.\d{1,}|\d{1,}]/g,
                                        /[^\d.]|(\.(?=.*\.))/g,
                                        ""
                                    );
                                } else {
                                    // return value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, "");
                                    return value.replace(/[^\d.]|(\.(?=.*\.))/g, "")
                                }
                            }}
                        >
                            {isPreview ? <span>{form.getFieldValue("registrationNumber") || '--'}</span> :
                                <LgInput
                                    maxLength={20}
                                    placeholder={'请输入中考报名号'}
                                    autoComplete='off'
                                    className="selfinput"
                                    onKeyPress={(event) => keyPureMath(event, ['+', 'e', 'E', '-', '.'])}
                                // onPressEnter={(event) => keyPureMath(event, ['+', 'e', 'E', '-', '.'])}
                                />
                            }
                        </Form.Item>
                    break;
                case 'parentPhone':
                    showCont = extramsg?.basicField?.parentPhone?.collect &&
                        <Form.Item
                            label="家长手机号"
                            name="parentPhone"
                            rules={[{
                                required: extramsg?.basicField?.parentPhone?.need, message: '家长手机号不能为空!'
                            }, ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || CheckPhone(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(
                                        new Error('手机号码格式有误')
                                    );
                                }
                            })]}
                        >
                            {isPreview ? <span>{form.getFieldValue("parentPhone") || '--'}</span> :
                                <LgInput maxLength={11} placeholder={'请输入家长手机号'} autoComplete='off' className="selfinput" />
                            }
                        </Form.Item>
                    break;
                case 'juniorScore':
                    showCont = extramsg?.basicField?.juniorScore?.collect &&
                        <Form.Item
                            label="中考成绩"
                            name="juniorScore"
                            rules={[{
                                required: extramsg?.basicField?.juniorScore?.need, message: '中考成绩不能为空!'
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (value && Number(value) < 0) {
                                        return Promise.reject(new Error('输入值要大于0'));
                                    }
                                    return Promise.resolve();
                                },
                            }),]}
                            getValueFromEvent={(e: any) => {
                                const { value } = e.target;
                                const tempArr = value.split(".");
                                if (tempArr[1]?.length) {
                                    return `${tempArr[0]}.${tempArr[1].slice(0, 1)}`.replace(
                                        // /[^\d{1,}\.\d{1,}|\d{1,}]/g,
                                        /[^\d.]|(\.(?=.*\.))/g,
                                        ""
                                    );
                                } else {
                                    // return value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g, "");
                                    return value.replace(/[^\d.]|(\.(?=.*\.))/g, "")
                                }
                            }}
                        >
                            {isPreview ? <span>{form.getFieldValue("juniorScore") || '--'}</span> :
                                <LgInput
                                    placeholder={'请输入中考成绩'}
                                    autoComplete='off'
                                    className="selfinput"
                                    maxLength={5}
                                // onKeyPress={(event) => handleKeyPress(event)}
                                />
                            }
                        </Form.Item>
                    break;
                case 'graduationSchool':
                    showCont = extramsg?.basicField?.graduationSchool?.collect &&
                        <Form.Item
                            label="毕业学校"
                            name="graduationSchool"
                            rules={[{
                                required: extramsg?.basicField?.graduationSchool?.need, message: '毕业学校不能为空!'
                            }]}
                        >
                            {isPreview ? <span>{form.getFieldValue("graduationSchool") || '--'}</span> :
                                <LgInput maxLength={32} placeholder={'请输入毕业学校'} autoComplete='off' className="selfinput" />
                            }
                        </Form.Item>
                    break;
                case 'majorName':
                    showCont = extramsg?.basicField?.majorName?.collect &&
                        <Form.Item
                            label="专业名称"
                            name="majorName"
                            initialValue={null}
                            rules={[
                                {
                                    required: extramsg?.basicField?.majorName?.need, message: '专业名称不能为空!'
                                }
                            ]}
                        >
                            {isPreview ?
                                <span>
                                    {
                                        extramsg?.basicField?.majorName?.options?.find((item: any) => item.value == form.getFieldValue("proCode"))?.name ||
                                        extramsg?.basicField?.majorName?.options?.find((item: any) => item.value == form.getFieldValue("proCode"))?.label ||
                                        '--'
                                    }
                                </span> :
                                <Select
                                    options={extramsg?.basicField?.majorName?.options?.map((item: any, index: number) => {
                                        return {
                                            label: item.name || item.label || '',
                                            value: item.value
                                        }
                                    })}
                                    placeholder="请选择专业名称"
                                    onChange={(_, curOption: any) => {
                                        const tempObj = majorList?.find((item: any) => item.proCode === curOption.value);
                                        form.setFieldsValue({
                                            majorName: curOption.value,
                                            proCode: curOption.value,
                                            studyPlace: tempObj?.campusId?.toString(),
                                        });
                                        forceUpdate({})
                                    }}
                                    className='CommonSelect majorName'
                                    // style={{ width: 400 }}
                                    getPopupContainer={(node) => node.parentNode}
                                />
                            }
                        </Form.Item>
                    break;
                case 'proCode':
                    showCont = extramsg?.basicField?.proCode?.collect &&
                        <Form.Item
                            label="专业代码"
                            name="proCode"
                            initialValue={null}
                            rules={[
                                {
                                    required: extramsg?.basicField?.proCode?.need, message: '专业代码不能为空!'
                                }
                            ]}
                        >
                            {isPreview ? <span>{form.getFieldValue("proCode") || '--'}</span> :
                                <Select
                                    options={extramsg?.basicField?.majorName?.options?.map((item: any, index: number) => {
                                        return {
                                            label: item.value,
                                            value: item.value
                                        }
                                    })}
                                    placeholder="请选择专业代码"
                                    onChange={(_, curOption: any) => {
                                        const tempObj = majorList?.find((item: any) => item.proCode === curOption.value);
                                        form.setFieldsValue({
                                            majorName: curOption.value,
                                            proCode: curOption.value,
                                            studyPlace: tempObj?.campusId?.toString(),
                                        });
                                        forceUpdate({})
                                    }}
                                    className='CommonSelect proCode'
                                    // style={{ width: 400 }}
                                    getPopupContainer={(node) => node.parentNode}
                                />
                            }
                        </Form.Item>
                    break;
                case 'studyPlace':
                    // 使用 Set 进行去重
                    const uniqueValues = extramsg?.basicField?.studyPlace?.options?.reduce((acc, obj) => {
                        if (!acc.find(item => item.value === obj.value)) {
                            acc.push(obj);
                        }
                        return acc;
                    }, []);

                    showCont = extramsg?.basicField?.studyPlace?.collect &&
                        <Form.Item
                            label={"就读地点"}
                            name="studyPlace"
                            rules={[{
                                required: extramsg?.basicField?.studyPlace?.need, message: '就读地点不能为空!'
                            }]}
                        >
                            {isPreview ? <span>
                                {
                                    uniqueValues.find((item: any) => item.value == form.getFieldValue("studyPlace"))?.name ||
                                    uniqueValues.find((item: any) => item.value == form.getFieldValue("studyPlace"))?.label ||
                                    form.getFieldValue("studyPlace") ||
                                    '--'
                                }
                            </span> :
                                <Select
                                    onChange={(value: any) => {
                                        const list = majorList.filter(ele => ele.campusId == value)
                                        const tempObj = form.getFieldsValue();

                                        list.find(item => item.proCode == tempObj.majorName)

                                        form.setFieldsValue({
                                            // proCode: value,
                                            // majorName: tempObj?.campusId?.toString(),
                                        });
                                    }}
                                    className="CommonSelect teminput"
                                    placeholder={'请选择就读地点'}
                                    disabled={true}
                                // style={{ width: 400 }}
                                >
                                    {
                                        uniqueValues?.map(
                                            (item: any, index: number) => {
                                                return (
                                                    <Select.Option
                                                        label={item.name || item.label || ''}
                                                        value={item.value}
                                                    >
                                                        {item.name || item.label || ''}
                                                    </Select.Option>
                                                );
                                            }
                                        )
                                    }
                                </Select>
                            }
                        </Form.Item>
                    break;
                case 'school1':
                    showCont = extramsg?.basicField?.school1?.collect &&
                        <Form.Item
                            label="毕业时间"
                            name="school1"
                            rules={[{
                                required: extramsg?.basicField?.school1?.need, message: '毕业时间不能为空!'
                            }]}
                        >
                            {isPreview ? <span>{form.getFieldValue("school1") || '--'}</span> :
                                <LgDatePicker value={null} placeholder="请选择毕业时间" style={{ height: 32 }} />
                            }
                        </Form.Item>
                    break;

                //南溪
                case 'graduationSchoolName':
                    let filterArr = extramsg?.basicField?.graduationSchoolName?.options.filter(item=>item.value===form.getFieldValue("graduationSchoolName"));
                    let schoolName = filterArr.length? filterArr[0].name: form.getFieldValue("graduationSchoolName");
                    if(schoolName && schoolName.indexOf("~")>-1){
                        schoolName = schoolName.substr(schoolName.indexOf("~")+1);
                    }
                    showCont = <Form.Item
                        label="毕业学校名称"
                        name="graduationSchoolName"
                        style={{
                            display: extramsg?.basicField?.graduationSchoolName?.collect ? 'flex' : 'none'
                        }}
                        rules={[{
                            required: extramsg?.basicField?.graduationSchoolName?.need, message: '毕业学校名称不能为空!'
                        }]}
                    >
                        {isPreview ? <span>{schoolName || '--'}</span> :
                           <CustomSchoolSelect
                            value={schoolName}
                            onChange={(value) => {
                                form.setFieldsValue({ graduationSchoolName: value });
                            }}
                            options={[
                                // 使用毕业学校名称对应的选项数据
                                ...(extramsg?.basicField?.graduationSchoolName?.options || []),
                                // 如果没有配置选项，使用默认的毕业学校选项作为备用
                                ...(!extramsg?.basicField?.graduationSchoolName?.options || 
                                    extramsg?.basicField?.graduationSchoolName?.options?.length === 0 ? 
                                    extramsg?.basicField?.graduationSchool?.options || [] : [])
                            ]}
                            placeholder="请选择毕业学校名称"
                            className="CommonSelect teminput"
                            onCustomSchoolSubmit={(schoolName) => {
                                // 处理自定义学校提交逻辑
                                console.log('自定义学校提交:', schoolName);
                                // 这里可以调用父组件的接口提交值
                                if (props.onCustomSchoolSubmit) {
                                    props.onCustomSchoolSubmit(schoolName);
                                }
                            }}
                        />
                        }
                        {/* {
                            isPreview?
                            <span>{schoolName||"--"}</span> :
                            <Input placeholder={'请输入毕业学校名称'} autoComplete='off' className="selfinput" />
                        } */}
                    </Form.Item>
                    break;
                case 'fatherName':
                    showCont = <Form.Item
                        label="父亲姓名"
                        name="fatherName"
                        style={{
                            display: extramsg?.basicField?.fatherName?.collect ? 'flex' : 'none'
                        }}
                        rules={[{
                            required: extramsg?.basicField?.fatherName?.need, message: '父亲姓名不能为空!'
                        }]}
                    >
                        {
                            isPreview?
                            <span>{form.getFieldValue("fatherName") || '--'}</span> :
                            <Input placeholder={'请输入父亲姓名'} autoComplete='off' className="selfinput" />
                        }
                    </Form.Item>
                    break;
                case 'fatherPhone':
                    showCont = <Form.Item
                        label="父亲手机号"
                        name="fatherPhone"
                        style={{
                            display: extramsg?.basicField?.fatherPhone?.collect ? 'flex' : 'none'
                        }}
                        rules={[{
                            required: extramsg?.basicField?.fatherPhone?.need, message: '父亲手机号不能为空!'
                        }]}
                    >
                        {
                            isPreview?
                            <span>{form.getFieldValue("fatherPhone") || '--'}</span> :
                            <Input placeholder={'请输入父亲手机号'} autoComplete='off' className="selfinput" />
                        }
                    </Form.Item>
                    break;
                case 'motherName':
                    showCont = <Form.Item
                        label="母亲姓名"
                        name="motherName"
                        style={{
                            display: extramsg?.basicField?.motherName?.collect ? 'flex' : 'none'
                        }}
                        rules={[{
                            required: extramsg?.basicField?.motherName?.need, message: '母亲姓名不能为空!'
                        }]}
                    >
                        {
                            isPreview?
                            <span>{form.getFieldValue("motherName") || '--'}</span> :
                            <Input placeholder={'请输入母亲姓名'} autoComplete='off' className="selfinput" />
                        }
                    </Form.Item>
                    break;
                case 'motherPhone':
                    showCont = <Form.Item
                        label="母亲手机号"
                        name="motherPhone"
                        style={{
                            display: extramsg?.basicField?.motherPhone?.collect ? 'flex' : 'none'
                        }}
                        rules={[{
                            required: extramsg?.basicField?.motherPhone?.need, message: '母亲手机号不能为空!'
                        }]}
                    >
                        {
                            isPreview?
                            <span>{form.getFieldValue("motherPhone") || '--'}</span> :
                            <Input placeholder={'请输入母亲手机号'} autoComplete='off' className="selfinput" />
                        }
                        
                    </Form.Item>
                    break;
                case 'juniorLanguageScore':
                    showCont = <Form.Item
                        label="中考语文成绩"
                        name="juniorLanguageScore"
                        style={{
                            display: extramsg?.basicField?.juniorLanguageScore?.collect ? 'flex' : 'none'
                        }}
                        rules={[{
                            required: extramsg?.basicField?.juniorLanguageScore?.need, message: '中考语文成绩不能为空!'
                        }]}
                    >
                        {
                            isPreview?
                            <span>{form.getFieldValue("juniorLanguageScore") || '--'}</span> :
                            <Input placeholder={'请输入中考语文成绩'} autoComplete='off' className="selfinput" />
                        }
                    </Form.Item>
                    break;
                case 'juniorMathScore':
                    showCont = <Form.Item
                        label="中考数学成绩"
                        name="juniorMathScore"
                        style={{
                            display: extramsg?.basicField?.juniorMathScore?.collect ? 'flex' : 'none'
                        }}
                        rules={[{
                            required: extramsg?.basicField?.juniorMathScore?.need, message: '中考数学成绩不能为空!'
                        }]}
                    >
                        {
                            isPreview?
                            <span>{form.getFieldValue("juniorMathScore") || '--'}</span> :
                            <Input placeholder={'请输入中考数学成绩'} autoComplete='off' className="selfinput" />
                        }
                    </Form.Item>
                    break;
                case 'juniorEnglishScore':
                    showCont = <Form.Item
                        label="中考英语成绩"
                        name="juniorEnglishScore"
                        style={{
                            display: extramsg?.basicField?.juniorEnglishScore?.collect ? 'flex' : 'none'
                        }}
                        rules={[{
                            required: extramsg?.basicField?.juniorEnglishScore?.need, message: '中考英语成绩不能为空!'
                        }]}
                    >
                        {
                            isPreview?
                            <span>{form.getFieldValue("juniorEnglishScore") || '--'}</span> :
                            <Input placeholder={'请输入中考英语成绩'} autoComplete='off' className="selfinput" />
                        }
                    </Form.Item>
                    break;
                case 'applyForMajor':
                    let name = extramsg?.basicField?.applyForMajor?.options.filter(item=>item.value===form.getFieldValue("applyForMajor"))[0]?.name;
                    showCont = <Form.Item
                        label="报读专业"
                        name={"applyForMajor"}
                        style={{
                            display: extramsg?.basicField?.applyForMajor?.collect? 'flex' : 'none'
                        }}
                        rules={[{
                            required: extramsg?.basicField?.applyForMajor?.need, message: '报读专业不能为空!'
                        }]}
                    >
                        {isPreview ? <span>{name || '--'}</span> :
                            <Select
                                options={extramsg?.basicField?.applyForMajor?.options?.map((item: any, index: number) => {
                                    return {
                                        label: item.name,
                                        value: item.value
                                    }
                                })}
                                placeholder="请选择报读专业"
                                onChange={(_, curOption: any) => {
                                    form.setFieldsValue({
                                        applyForMajor: curOption.value
                                    });
                                }}
                                className='CommonSelect proCode'
                                style={{ width: 183 }}
                                getPopupContainer={(node) => node.parentNode}
                            />
                        }
                    </Form.Item>
                    break;
                default:
                    break;
            }
            
            //锦州新增字段
            if(jinzhouTemplateParams.filter(child=>child.key === item).length){
                let data = jinzhouTemplateParams.filter(child=>child.key === item)[0];
                console.log(data, extramsg?.basicField?.[data.key], 'option')
                if(data.type === 1){  //输入框
                    showCont = extramsg?.basicField?.[data.key]?.collect && (
                    <Form.Item
                        label={data.name}
                        name={data.key}
                        rules={[{ required: extramsg?.basicField?.[data.key]?.need, message: `${data.name}不能为空!` }]}
                    >
                        {isPreview ? <span>{form.getFieldValue(data.key) || '--'}</span> :
                        <Input
                            maxLength={25}
                            placeholder={`请输入${data.name}`}
                            autoComplete="off"
                            className="selfinput"
                        />
                        }
                    </Form.Item>
                    );
                } else if(data.type === 2){  //数字输入框
                showCont = extramsg?.basicField?.[data.key]?.collect && <NumericInput
                form={form}
                extramsg={extramsg}
                label={data.name}
                name={data.key}
                max={99999999}
                isPreview={isPreview}
                />;
                } else if(data.type === 3) {  //下拉框
                showCont = extramsg?.basicField?.[data.key]?.collect && <Form.Item
                label={data.name}
                name={data.key}
                rules={[{
                    required: extramsg?.basicField?.[data.key]?.need, message: `${data.name}不能为空!`
                }]}
                >
                {isPreview ?
                    <span>
                    {
                        extramsg?.basicField?.[data.key]?.options?.find((item: any) => item.value == form.getFieldValue(data.key))?.name ||
                        extramsg?.basicField?.[data.key]?.options?.find((item: any) => item.value == form.getFieldValue(data.key))?.label ||
                        '--'
                    }
                    </span> :
                    <Select
                    onChange={(value: any) => {
                        //毕业学校代码和毕业学校名称要联动
                        if(data.key === "graduationSchoolCode"){
                            form.setFieldsValue({
                            graduationSchoolName: extramsg?.basicField?.graduationSchoolName?.options?.find((item: any) => item.value == form.getFieldValue("graduationSchoolCode"))?.name
                            });
                        } else if(data.key === "graduationSchoolName"){
                            form.setFieldsValue({
                            graduationSchoolCode: extramsg?.basicField?.graduationSchoolCode?.options?.find((item: any) => item.value == form.getFieldValue("graduationSchoolName"))?.name
                            });
                        } else if(data.key.indexOf("jzMajor")>-1) {
                            let info = form.getFieldsValue();
                            let list = [];
                            for(let key in info){
                                if(key.indexOf("jzMajor")>-1 && key !== data.key){
                                list.push(info[key]);
                                }
                            }
                            if(value && list.includes(value)){
                                message.warning("已选择相同专业");
                                form.setFieldsValue({
                                    [data.key]: undefined
                                });
                                return;
                            }
                        }
                        form.setFieldsValue({
                            [data.key]: value
                        });
                    }}
                    className="CommonSelect teminput"
                    placeholder={`请选择您的${data.name}`}
                    getPopupContainer={(node) => node.parentNode}
                    >
                    {extramsg?.basicField?.[data.key]?.options?.map(
                        (item: any, index: number) => {
                        return (
                            <Select.Option
                            label={item.name || item.label || ''}
                            value={item.value}
                            >
                            {item.name || item.label || ''}
                            </Select.Option>
                        );
                        }
                    )}
                    </Select>
                }
                </Form.Item>
                } else { 
                showCont = extramsg?.basicField?.[data.key]?.collect && <Form.Item
                    label={data.name}
                    name={data.key}
                    rules={[{
                        required: extramsg?.basicField?.[data.key]?.need, message: `${data.name}不能为空!`
                    }]}
                    initialValue={1}
                    >
                    {isPreview ? <span>{form.getFieldValue(data.key)? form.getFieldValue(data.key)==1? "是": "否":"--"}</span> :
                        <Radio.Group>
                        <Radio value={1}>是</Radio>
                        <Radio value={0}>否</Radio>
                        </Radio.Group>
                    }
                    </Form.Item>
                }
            }
            return showCont ? {
                type: item,
                dom: <div
                    className="baseicReportItem"
                    style={{ width: type === 3 ? '100%' : (item === 'avatar' && showCont ? 0 : null) }}
                    key={item}
                    date-type={item}
                >
                    {showCont}
                </div>
            } : null
        }).filter(Boolean);


        if (selectItem?.planType === 1 && selectItem?.courseList?.length > 0) {
            list.push({
                type: 'courseList',
                dom: <div
                    className="baseicReportItem courseList"
                    key='courseList'
                    date-type='courseList'
                    style={{ width: type === 3 ? '100%' : null }}
                >
                    <Form.Item
                        label="报读学科"
                        name="courseList"
                        initialValue={[]}
                        rules={[{
                            required: !isPreview,
                            message: '报读学科不能为空!'
                        }]}
                    >
                        {isPreview ? <span title={form.getFieldValue("courseList").map(ele => selectItem.courseList.find(el => el.subjectId === ele)?.subjectName)?.join('、')}>
                            {form.getFieldValue("courseList").map(ele => selectItem.courseList.find(el => el.subjectId === ele)?.subjectName)?.join('、') || '--'}
                        </span> :
                            <Select
                                placeholder={`请选择报读学科`}
                                mode="multiple"
                                onChange={(value) => {
                                    let temp = form.getFieldValue('courseList') || []
                                    if (selectItem.subjectNum < value.length) {
                                        form.setFieldsValue({ courseList: temp.splice(0, selectItem.subjectNum) });
                                        message.destroy();
                                        message.warning('最多可选' + selectItem.subjectNum + '个学科');
                                        setPageKey(pageKey + 1);
                                        return
                                    }
                                    form.setFieldsValue({ courseList: value });
                                    setPageKey(pageKey + 1);
                                }}
                                className="CommonSelect"
                                style={{ width: "100%" }}
                                autoClearSearchValue={false}
                                showSearch={false}
                                getPopupContainer={(node) => node.parentNode}
                            >
                                {selectItem.courseList?.map((item: any, index: number) => {
                                    const courseList = form.getFieldValue('courseList') || [];
                                    console.log(item, 'item');

                                    return <Select.Option
                                        key={item?.subjectId}
                                        label={item?.subjectName}
                                        value={item?.subjectId}
                                        className="multiple_select"
                                    >
                                        <LgCheckbox
                                            checked={courseList?.includes(item.subjectId)}
                                            onChange={(e: boolean) => {
                                                if (e && (selectItem.subjectNum < courseList.length || selectItem.subjectNum === courseList.length)) {
                                                    form.setFieldsValue({ courseList: courseList });
                                                    message.destroy();
                                                    message.warning('最多可选' + selectItem.subjectNum + '个学科');
                                                    setPageKey(pageKey + 1);
                                                    return
                                                }
                                                form.setFieldsValue({
                                                    courseList: e ? [...courseList, item.subjectId] : courseList.filter(value => value !== item.subjectId)
                                                })
                                                setPageKey(pageKey + 1);
                                            }}
                                            value={item.subjectId}
                                            label=''
                                        />
                                        {item?.subjectName || item?.label || ''}
                                    </Select.Option>
                                })}
                            </Select>
                        }
                    </Form.Item>
                </div >
            })
        }


        const avatar = list.find(item => item?.type === 'avatar')
        if (extramsg?.basicField?.avatar?.collect && avatar) {
            const newArr = list.filter(v => v?.type !== 'avatar');
            const res = [];
            const rowIndex = [2, 4, 6, 8];
            let cnt = isPreview ? 6 : 4; //图片占的行数
            for (let i = 0; i < newArr.length; i++) {
                // if (cnt !== 0 && rowIndex.includes(i)) {
                if (cnt !== 0 && i > 1 && i % 2 === 0) {
                    res.push({
                        type: 'default',
                        dom: <div className="baseicReportItem"></div>
                    });
                    cnt--;
                }
                res.push(newArr[i]);
            }
            res.push({
                type: 'avatar',
                dom: avatar.dom
            });
            list = res
        }
        return list
    }, [basicOrdere, type, avatr, isPreview, formKey, pageKey, majorList]);

    const handleValuesChange = (changedValues, allValues) => {
        const { trainingStage } = changedValues; // 获取 changedValues 中的 培养层次
        if (trainingStage !== undefined) {
            setFormKey(formKey + 1); // 修改 formKey 的值
        }
    };

    return (
        <>
        <div className={`reportTpt wjz_spin_div ${type !== 3 ? '' : 'reportTpt_priview'} ${isPreview ? 'reportTpt_isPreview' : ''}`}>
            <Spin spinning={isloading}>
                {/* <Scrollbars style={{ minHeight: 200, height: '100%' }}> */}
                <div className="baseic">
                    <div className="title">
                        <i className="baseico" />
                        基本信息
                    </div>
                    <div
                        className="report"
                        style={{
                            minHeight: extramsg?.basicField?.avatar?.collect ? '160px' : 'unset'
                        }}
                    >
                        <Form
                            form={form}
                            name="basicinfo"
                            className="selfmsg"
                            validateTrigger={['onBlur']}
                            key={formKey}
                            onValuesChange={handleValuesChange}
                        >
                            {baseInfoList?.map(v => v?.dom)}
                        </Form>
                    </div>
                </div>
                {
                    extramsg?.fields?.length > 0 &&
                    <div className="extra">
                        <div className="split"></div>
                        <div className="title">
                            <i className="extraico" />
                            补充信息
                        </div>
                        <div className="report">
                            <Form
                                validateTrigger={['onBlur']}
                                form={extraform}
                                name="extrainfo"
                                // labelCol={{ span: isPreview ? 7 : type !== 3 ? 5 : 6 }}
                                // wrapperCol={{ span: 17 }}
                                // labelCol={{ span: 10 }}
                                // wrapperCol={{ span: 14 }}
                                className="extramsg"
                            >
                                <Row gutter={24}>
                                    {
                                        extramsg?.fields?.map((item, index: number) => {
                                            return <Col span={getColSpan(item)} key={'extra' + index}>
                                                <ExtraItem
                                                    form={extraform}
                                                    editmsg={editmsg}
                                                    isPreview={isPreview}
                                                    setfile={(value: any) => setfile(value)}
                                                    name={'extra' + index + 1}
                                                    item={item}
                                                    key={'extra' + index}
                                                    type={type}
                                                />
                                            </Col>
                                        })
                                    }
                                </Row>
                            </Form>
                        </div>
                    </div>
                }
                {/* </Scrollbars> */}
            </Spin>
        </div>
        <Modal
                title={""}
                footer={null}
                rootClassName='enroll-sucess-modal'
                visible={modalVisible}
                onCancel={() => {
                    setModalVisible(false);
                    setModalTip("");
                }}
            >
                <div className='sucess-modal-content'>
                    <svg className='tip-logo' viewBox="0 0 1024 1024" width="64" height="64"><path d="M874.119618 149.859922A510.816461 510.816461 0 0 0 511.997 0.00208a509.910462 509.910462 0 0 0-362.119618 149.857842c-199.817789 199.679789-199.817789 524.581447 0 724.260236a509.969462 509.969462 0 0 0 362.119618 149.857842A508.872463 508.872463 0 0 0 874.119618 874.120158c199.836789-199.679789 199.836789-524.581447 0-724.260236zM814.94268 378.210681L470.999043 744.132295a15.359984 15.359984 0 0 1-5.887994 4.095996c-1.751998 1.180999-2.913997 2.362998-5.276994 2.913997a34.499964 34.499964 0 0 1-13.469986 2.914997 45.547952 45.547952 0 0 1-12.897986-2.303998l-4.095996-2.363997a45.291952 45.291952 0 0 1-7.009992-4.095996l-196.902793-193.789796a34.126964 34.126964 0 0 1-10.555989-25.186973c0-9.37399 3.583996-18.74698 9.98399-25.186974a36.429962 36.429962 0 0 1 50.372947 0l169.98382 167.423824L763.389735 330.220732a37.059961 37.059961 0 0 1 50.371947-1.732998 33.647965 33.647965 0 0 1 11.165988 25.186973 35.544963 35.544963 0 0 1-9.98399 24.575974v-0.04z m0 0" fill="#52C41A"></path></svg>
                    <p>{modalTip}~</p>
                    <p className='tip-text'>
                        <svg viewBox="0 0 1024 1024" width="16" height="16"><path d="M511.315408 64.117296c-114.365724 0-228.732471 43.446511-316.263014 130.978077-174.424588 174.424588-174.424588 458.102463 0 632.527051 87.531566 87.531566 201.89729 130.978077 316.263014 130.978077s228.731448-43.446511 316.263014-130.978077c174.424588-174.423565 174.424588-458.102463 0-632.527051C740.04788 107.563808 625.682155 64.117296 511.315408 64.117296zM511.315408 108.841917c52.391231 0 103.504352 10.222829 151.422711 29.390377 49.835012 20.445658 94.559633 49.835012 132.894729 88.809675 38.97364 38.335097 68.364017 83.058694 88.809675 132.894729 19.167548 47.918359 29.390377 99.031481 29.390377 151.422711s-10.222829 103.504352-29.390377 151.422711c-20.445658 49.835012-49.835012 94.559633-88.809675 132.894729-38.335097 38.97364-83.058694 68.364017-132.894729 88.809675-47.918359 19.167548-99.031481 29.390377-151.422711 29.390377s-103.504352-10.222829-151.422711-29.390377c-49.835012-20.445658-94.559633-49.835012-132.894729-88.809675-38.97364-38.335097-68.364017-83.058694-88.809675-132.894729-19.167548-47.918359-29.390377-99.031481-29.390377-151.422711s10.222829-103.504352 29.390377-151.422711c20.445658-49.835012 49.835012-94.559633 88.809675-132.894729 38.335097-38.97364 83.058694-68.364017 132.894729-88.809675C407.811056 119.064746 458.924177 108.841917 511.315408 108.841917z" fill="#FF7F28" p-id="3854"></path><path d="M516.619204 713.1206c13.227256 0 24.582885 4.617158 34.066887 13.851473 9.484002 9.234315 14.226003 20.465101 14.226003 33.692357 0 13.476943-4.742001 24.77015-14.226003 33.879622-9.484002 9.109472-20.839631 13.664208-34.066887 13.664208-13.227256 0-24.582885-4.554736-34.066887-13.664208s-14.226003-20.402679-14.226003-33.879622c0-13.227256 4.742001-24.458041 14.226003-33.692357C492.036319 717.737758 503.391948 713.1206 516.619204 713.1206zM553.306778 219.333404l-8.235568 414.796144L485.921042 634.129548l-8.235568-414.796144L553.306778 219.333404z" fill="#FF7F28"></path></svg>
                        <div>提示：你报名的考生号不是三校生考生号，请提供相关证明材料，并主动联系我校招生办。</div>
                    </p>
                </div>
            </Modal>
        </>
        
    )
})
export default AddOrupEnroll
